import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosServiceShop from 'src/utils/axiosWOBaseUrl';



export const setMaterialServiceShopData = createAsyncThunk('/SetMaterialServiceShopData', async (data) => {
    const response = await axiosServiceShop.post(
      '/ServiceShop/SetMaterialServiceShopData',
      data
    );
    return response.data;
  });


  export const getMaterialServiceShopData = createAsyncThunk(
    '/GetMaterialServiceShop',
    async () => {
      const response = await axiosServiceShop.get(
        '/ServiceShop/GetMaterialServiceShopForHo/0'
      );
      return response.data;
    }
  );

  
export const getDeleteMaterialServiceShopData = createAsyncThunk(`/GetDeleteMaterialServiceShopData`, async (id) => {
  const response = await axiosServiceShop.get(`/ServiceShop/GetDeleteMaterialServiceShopData/${id}`);
  return response.data;
});


const materialServiceShopSlice = createSlice({
  name: 'materialServiceShop',
  initialState: {
    loading: false,
    success : false,
    error: '',
    MaterialServiceShopData:[]
  },
  reducers: {
  },
  extraReducers: {  
    [getMaterialServiceShopData.pending]: (state) => {
        state.loading = true;
      },
      [getMaterialServiceShopData.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getMaterialServiceShopData.fulfilled]: (state, action) => {
        state.MaterialServiceShopData = action.payload;
        state.loading = false;
      },
      [setMaterialServiceShopData.pending]: (state) => {
        state.loading = true;
       },
      [setMaterialServiceShopData.rejected]: (state, action) => {
        state.error = action.error;
        state.success=false;
        state.loading = false;
      },
      [setMaterialServiceShopData.fulfilled]: (state, action) => {
        state.response = action.payload;
        state.success=true;
        state.loading = false;    
      },
      [getDeleteMaterialServiceShopData.pending]: (state) => {
        state.loading = true;
      },
      [getDeleteMaterialServiceShopData.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getDeleteMaterialServiceShopData.fulfilled]: (state, action) => {
        state.success=true;
        state.loading = false;
         state.response = action.payload;
      }
  }
});
export const materialServiceShopSliceActions = materialServiceShopSlice.actions;
export default materialServiceShopSlice;
